import { ReactElement, RefObject, useContext, useEffect, useMemo, useRef, useState } from 'react'
import door_closed from 'url:../../assets/phck/fm/Door - Cartoon.png';
import door_open from 'url:../../assets/phck/Door---Cartoon-open.png';
import booth_off from 'url:../../assets/phck/payphone-sleep.png';
import booth_on from 'url:../../assets/phck/payphone-wake.gif';
import board from 'url:../../assets/phck/board.png';
import dogfood from 'url:../../assets/phck/Dog & Food 09.png';
import goofems from 'url:../../assets/phck/GREATGOOFEMS-GREATGOOFEMS.png';
import fridge from 'url:../../assets/phck/Refrigerator 14.png';
import weiner from 'url:../../assets/phck/weinervortex.gif';
import weiner_off from 'url:../../assets/phck/frozenweiner.png';
import barn from 'url:../../assets/phck/Animals - Barn.png';
import cow from 'url:../../assets/phck/Cow 17.png';
import road from 'url:../../assets/phck/road.png';
import chicken from 'url:../../assets/phck/Chicken 02.png';
import lamb from 'url:../../assets/phck/Lamb with Bow.png';
import cat from 'url:../../assets/phck/Cat on Skateboard.png';
import scary1 from 'url:../../assets/phck/scaryjokes.png';
import scary2 from 'url:../../assets/phck/scaryjokes2.png';
import general from 'url:../../assets/phck/General Jokes.png';
import '../../styles/phranks.css'
import joke_sheet from '../../data/jokes.json';
import fart from 'url:../../assets/fart.mp3';
import { StampCollection } from '../../components/StampCollection';
import { StampType } from '../../components/Stamp';
import { SlotDrag } from '../../components/cursor/draggables/SlotDrag';
import PlayerProvider from '../../providers/PlayerProvider';
import { SITE_INFO_PHRK } from '../../providers/SitesProvider';
import { IsWithin } from '../../utility/Rects';
import { FreeDrag } from '../../components/cursor/draggables/FreeDrag';
import { Plzen } from '../../components/cursor/plz/Plzen';
import { Plzma } from '../../components/cursor/plz/Plzma';
import { useNavigate } from 'react-router';

class JokeTracker
{
    nodes: ReactElement[] = [];
    words: string[] = [];
}

export function PCH() {
    const player = useContext(PlayerProvider.context);

    useEffect(() => {
        player.unlockSite(SITE_INFO_PHRK.key);
    }, []);


    const [rndr, setRndr] = useState(0);
    const rndrRef = useRef(0);
    const wordIndex = useRef(0);
    const jokeIndex = useRef(-1);
    const jokeMaximum = useRef(0);
    const doorState = useRef(0);
    const mainTracker = useRef(new JokeTracker());
    const jokesTracker = useRef(new JokeTracker());
    const freeTracker = useRef(new JokeTracker());
    const audioRef = useRef(new Audio(fart));
    const jokeBoxRef = useRef<HTMLDivElement>(HTMLDivElement.prototype);
    const boothBoxRef = useRef<HTMLDivElement>(HTMLDivElement.prototype);
    const doorBoxRef = useRef<HTMLDivElement>(HTMLDivElement.prototype);

    const onMainWordDrop = (r: RefObject<HTMLDivElement>) => 
    {
        var wordRect = r.current.getBoundingClientRect();
        var boxRect = jokeBoxRef.current.getBoundingClientRect();
        const within = IsWithin(wordRect, boxRect, true);
        if (!within)
        {
            var jokeNode = mainTracker.current.nodes.find(n => n.key == r.current.id);
            if (jokeNode !== undefined)
            {
                const jokeIndex = mainTracker.current.nodes.indexOf(jokeNode);
                const word = mainTracker.current.words[jokeIndex];
                mainTracker.current.nodes.splice(jokeIndex, 1,
                    <p key={r.current.id} className='hyphen-nobreak all-caps hidden'>{word}</p>
                );

                if (!checkJokeLandingFull(r, jokeNode, word, jokeIndex, mainTracker.current))
                {
                    freeTracker.current.words.push(word);
                    freeTracker.current.nodes.push(
                        <FreeDrag
                            id={r.current.id}
                            key={r.current.id}
                            x={wordRect.x}
                            y={wordRect.y}
                            onDragEnded={onFreeWordDrop}
                        >
                            <p className='hyphen-nobreak all-caps'>{word}</p>
                        </FreeDrag>
                    );
                }
                else
                    setRndr(rndrRef.current + 1);
            }
        }
    };

    const onJokeWordDrop = (r: RefObject<HTMLDivElement>) =>
    {
        checkJokeLanding(r, jokesTracker.current);
    };

    const onFreeWordDrop = (r: RefObject<HTMLDivElement>) =>
    {
        checkJokeLanding(r, freeTracker.current);
    };

    const checkJokeLanding = (r: RefObject<HTMLDivElement>, tracker: JokeTracker) : boolean => 
    {
        console.log(r.current.id);
        console.log(tracker.nodes);
        const node = tracker.nodes.find(n => n.key == r.current.id);
        if (node === undefined)
            return false;
        const index = tracker.nodes.indexOf(node);
        const word = tracker.words[index];
        return checkJokeLandingFull(r, node, word, index, tracker);
    };

    const checkJokeLandingFull = (r: RefObject<HTMLDivElement>, node: ReactElement, word: string, index: number, tracker: JokeTracker): boolean =>
    {
        const box = r.current.getBoundingClientRect();
        const wordLower = word.toLowerCase();

        const qValid = wordLower.includes("quarter");
        if (qValid && IsWithin(box, boothBoxRef.current.getBoundingClientRect(), true))
        {
            tracker.nodes.splice(index, 1, <p key={r.current.id} className='hyphen-nobreak all-caps hidden'>{word}</p>);
            jokeMaximum.current++;
            setRndr(rndrRef.current + 1);
            return true;
        }

        let dValid = false;
        switch (doorState.current)
        {
            case 0:
                dValid = wordLower.includes("knock");
                break;
            case 1:
                dValid = wordLower.includes("doris");
                break;
            case 2:
                dValid = wordLower.includes("open");
                break;
        }
        if (dValid && IsWithin(box, doorBoxRef.current.getBoundingClientRect(), true))
        {
            tracker.nodes.splice(index, 1, <p key={r.current.id} className='hyphen-nobreak all-caps hidden'>{word}</p>);
            doorState.current++;
            setRndr(rndrRef.current + 1);
            return true;
        }

        console.log("dropped: " + word + " (" + r.current.id + ")");
        return false;
    }

    const cycleJoke = () => {
        jokeIndex.current++;
        if (jokeIndex.current >= jokeMaximum.current)
            jokeIndex.current = 0;
        const nextJoke = joke_sheet.favorites[jokeIndex.current];
        mainTracker.current.words = nextJoke.split(' ');
        mainTracker.current.nodes = mainTracker.current.words.map((s, i) => {
            const id = 'wrd-' + (wordIndex.current + i + 1);
            return <SlotDrag
                id={id}
                key={id}
                onDropped={onMainWordDrop}
            >
                <p className='hyphen-nobreak all-caps'>{s}</p>
            </SlotDrag>
        });
        wordIndex.current += mainTracker.current.words.length;
        setRndr(rndrRef.current + 1);
    };

    useEffect(() => {
        rndrRef.current = rndr;
    }, [rndr]);

    const fartSound = () => {
        audioRef.current.play();
        setRndr(rndrRef.current + 1);
    }
    
    const page = useMemo(() => {
        return <div className='phranks-page'>
            <div className='phranks-body'>
                <div className='v-box gap-16 center-all'>
                    <div className='h-box gap-16 pos-rel'>
                        <Plzma
                            className='pos-abs'
                            style={{
                                top: 100,
                                left: -200
                            }}
                            offState={
                                <img src={booth_off} className='width-256' />
                            }
                            onState={
                                <img src={booth_on} className='width-256' />
                            }
                        />
                        <div ref={boothBoxRef} className='pos-abs no-events' style={{ top: 100, left: -200, width: 256, height: 384}} />
                        <div className='phranks-header v-box align-end width-512'>
                            <h1>PHRANKS CRANK'S</h1>
                            <h2>DON'T KNOCK IT TILL YOU TRY IT!</h2>
                        </div>
                        <PCD state={doorState.current} />
                        <div ref={doorBoxRef} className='pos-abs no-events' style={{ top: 0, right: 0, width: 256, height: 256}} />
                    </div>
                    <div className='phranks-funbox'>
                        <button className='phranks-jokebutton' onClick={fartSound}>FART</button>
                        {
                            jokeMaximum.current > 0
                                ? <button className='phranks-jokebutton' onClick={cycleJoke}>JOKE ({jokeIndex.current + 1}/{jokeMaximum.current})</button>
                                : <button className='phranks-jokebutton' disabled>JOKE</button>
                        }
                    </div>
                    <div className='phranks-jokebox v-box height-96 pos-rel' ref={jokeBoxRef}>
                        {/* <img src={banner} className='pos-abs width-100p height-100p' style={{top:0, left:0}} /> */}
                        <div className='phranks-jokewords h-box' ref={jokeBoxRef}>
                            {mainTracker.current.nodes}
                        </div>
                    </div>
                </div>
                <div className='v-box height-128 text-24'>
                    We've got...
                    <div className='h-box'>
                        <ul>
                            <li><a href='#animaljokes'>Animal Jokes</a></li>
                            <li><a href='#scaryjokes'>Scary Jokes</a></li>
                        </ul>
                        <ul>
                            <li><a href='#generaljokes'>General Jokes</a></li>
                            <li><a href='#andmorejokes'>And More!</a></li>
                        </ul>
                    </div>
                </div>
                <div className='v-box center-all gap-16'>
                    <div className='height-128 center-all v-box'>
                        <img src={goofems} className='width-768 no-events' style={{transform:"rotateZ(15deg)"}} />
                    </div>
                    <div className='h-box gap-16 align-center'>
                        <div className='v-box pos-rel width-640 height-384'>
                            <img src={board} className='pos-abs width-100p height-100p' style={{top:0, left:0}} />
                            <img src={dogfood} className='pos-abs width-128' style={{right: 48, top: 48}} />
                            <h3 className='phranks-banner padding-16 pos-abs text-white text-32 all-caps' style={{left:32, top:16}}>Joke of the Week</h3>
                            <div className='phranks-text-yellow text-32 pos-abs width-384' style={{left: 64, top: 128}}>What did the boy who swallowed a coin ask the doctor?</div>
                            <div className='phranks-text-yellow text-24 pos-abs' style={{left: 64, top: 292, width: 420}}>Doctor, do you see any change in me?</div>
                        </div>
                        <div className='v-box center-all pos-rel'>
                            <Plzma
                                startOn={true}
                                onState={
                                    <img src={weiner} className='width-128 pos-abs' style={{
                                        left: 32,
                                        top: -32
                                    }} />
                                }
                                offState={
                                   <img src={weiner_off} className='width-128 pos-abs filter-grayscale' style={{
                                        left: 32,
                                        top: -32
                                    }} />
                                }
                            />
                            <div className='height-96' />
                            <div className='v-box width-192 bg-blue phranks-text-yellow padding-4'>
                                <h3 className='text-32'>FUNNY WORDS</h3>
                                <ul>
                                    <li>superfluous</li>
                                    <li>pamplemousse</li>
                                    <li>llama</li>
                                    <li>defenestration</li>
                                    <li>flabbergast</li>
                                    <li>bunghole</li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
                <JokesSection id="animaljokes" header='On the Farm' jokes={joke_sheet.animal} wordIndex={wordIndex} tracker={jokesTracker.current} onDragWord={onJokeWordDrop} middle={
                    <div className='pos-rel' style={{width: 1280/2, height: 378/2}}>
                        <FME src={barn} x={61.80} y={0.26} w={32.58} />
                        <FME src={cow} x={54.30} y={55.82} w={8.28} />
                        <FME src={road} x={2.34} y={37.04} w={50.55} />
                        <FME src={chicken} x={46.95} y={51.59} w={4.77} />
                        <FME src={lamb} x={86.48} y={68.52} w={7.97} />
                        <FME src={cat} x={19.30} y={30.16} w={10.31} r={25} />
                        <div className='bg-blue height-4 pos-abs' style={{top: "100%", left:0, right: 0}} />
                    </div>
                } />
                <JokesSection id="scaryjokes" header='Scary Stuff' jokes={joke_sheet.scary} wordIndex={wordIndex} tracker={jokesTracker.current} onDragWord={onJokeWordDrop} bonus={
                    <>
                        <img src={scary1} className='pos-abs' style={{top:-32, left:-32, width:96}} />
                        <img src={scary2} className='pos-abs' style={{top:-16, right:-32, width:128}} />
                    </>
                } />
                <JokesSection id="generaljokes" header='General' jokes={joke_sheet.general} wordIndex={wordIndex} tracker={jokesTracker.current} onDragWord={onJokeWordDrop} bonus={
                    <img src={general} className='pos-abs' style={{top:16, right: -16, width:96}} />
                } />
                <JokesSection id="andmorejokes" header='And More...' jokes={joke_sheet.more} wordIndex={wordIndex} tracker={jokesTracker.current} onDragWord={onJokeWordDrop} />
                <div className='h-box'>
                    <img src={fridge} className='height-96' />
                    <div className='v-box'>
                        <h3 className='text-24 all-caps'>Hungry for more websites???</h3>
                        <StampCollection stamps={[
                            StampType.Cryptid,
                            StampType.TacoBongo,
                            StampType.Anime,
                            StampType.WTROK
                        ]} />
                    </div>
                </div>
                <div>
                    {freeTracker.current.nodes}
                </div>
            </div>
        </div>
    }, [rndr]);

    return page;
}

function JokesHeader(props: {
    id: string,
    header: string
}) {
    return <div id={props.id} className='phranks-banner pos-rel v-box center-all'>
        <h3 className='text-64 text-blue padding-16 all-caps'>{props.header}</h3>
    </div>
}

function JokesSection(props: {
    id: string,
    header: string,
    jokes: string[],
    wordIndex: RefObject<number>,
    tracker: JokeTracker,
    onDragWord: (r: RefObject<HTMLDivElement>) => void,
    middle ?: React.ReactNode,
    bonus ?: React.ReactNode
}) {
    return <div className='v-box gap-32 width-640 pos-rel'>
        <JokesHeader header={props.header} id={props.id} />
        { props.middle }
        <div className='v-box gap-16'>
            {
                props.jokes.map((j, i) => {
                    const jokeWords = j.split(' ');
                    const jokeNodes = jokeWords.map((k, l) => {
                        const id = 'wrd-' + (props.wordIndex.current + l + 1);
                        return <SlotDrag
                            id={id}
                            key={id}
                            onDropped={props.onDragWord}
                        >
                            <p className='hyphen-nobreak'>{k}</p>
                        </SlotDrag>
                    });
                    props.tracker.words.push(...jokeWords);
                    props.tracker.nodes.push(...jokeNodes);
                    props.wordIndex.current += jokeWords.length;
                    const jokeDiv = <div key={i} className='phranks-jokewords h-box align-start'>
                        { jokeNodes }
                    </div>;
                    return jokeDiv;
                })
            }
        </div>
        { props.bonus }
    </div>
}

function PCD (props: {
    state: number
}) {
    const nav = useNavigate();
    const img = props.state >= 3 ? door_open : door_closed;
    const onclick = props.state >= 3 ? () => {
        nav('/thecomedyshow');
    } : () => {};
    let text = "";
    if (props.state == 1)
        text = "Who's there?";
    else if (props.state == 2)
        text = "Doris who?";
    return <>
        <img src={img} className='height-256 pos-rel' onClick={onclick} />
        <div className='pos-abs' style={{ top:256, right:0}}>
            <p>{text}</p>
        </div>
    </>
}

function FME (props: {
    src: string,
    x: number,
    y: number,
    w: number,
    h?: number,
    r?: number
}) {
    const r = props.r !== undefined ? props.r : 0;
    if (props.h !== undefined)
        return <img src={props.src} className='pos-abs' style={{
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%",
            height: props.h + "%",
            transform: "rotateZ(" + r + "deg)"
        }} />
    return <img src={props.src} className='pos-abs' style={{
        left: props.x + "%",
        top: props.y + "%",
        width: props.w + "%",
        transform: "rotateZ(" + r + "deg)"
    }} />
}